import { render, staticRenderFns } from "./SimilarList.vue?vue&type=template&id=0eca9e84&scoped=true&"
import script from "./SimilarList.vue?vue&type=script&lang=ts&"
export * from "./SimilarList.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarList.vue?vue&type=style&index=0&id=0eca9e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eca9e84",
  null
  
)

export default component.exports